const priorityColors = {
  1: { bg: '#2d0a0a', text: '#f87171' },
  2: { bg: '#2d1a0a', text: '#fb923c' },
  3: { bg: '#2d2a0a', text: '#facc15' },
  4: { bg: '#0a1a2d', text: '#60a5fa' },
  5: { bg: '#1e293b', text: '#94a3b8' },
};

const success = '#22c55e';
const destructive = '#ef4444';

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

module.exports = { priorityColors, success, destructive, hexToRgba };
